import React from "react";
import { useParams, Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import FooterTwo from "../components/footer/FooterTwo";
import EmersonHeader from "../components/header/EmersonHeader";
import { generateSlug, useSolution } from "../services/solutionsService";

function SolutionDetails() {
  const { slug } = useParams();
  const { data: solution, isLoading: loading } = useSolution(slug);

  if (loading) {
    return (
      <div>
        <EmersonHeader />
        <div className="container text-center py-5">
          <p>Loading solution...</p>
        </div>
        <FooterTwo />
      </div>
    );
  }

  if (!solution) {
    return (
      <div>
        <EmersonHeader />
        <div className="container text-center py-5">
          <h2>Solution Not Found</h2>
          <Link to="/" className="rts-btn btn-primary">
            View All Solutions
          </Link>
        </div>
        <FooterTwo />
      </div>
    );
  }
  console.log("solution", solution._original);

  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Solutions", link: `/solutions/${generateSlug(solution.name)}` },
    { label: solution.name },
  ];

  return (
    <div className="analyser-house-solution-page">
      <EmersonHeader />
      <Breadcrumb
        title={solution.name}
        breadcrumbs={breadcrumbs}
        breadcrumbBg={
          solution._original.banner_image
            ? `${process.env.REACT_APP_API_URL}/assets/banner_image/solution/${solution._original.banner_image}`
            : "/assets/images/breadcrumb/01.jpg"
        }
      />

      {/* Overview Section */}
      <div className="rts-about-area rts-section-gap solution-overview-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                <p
                  className="brand-promise-tagline"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#DF0A0A",
                    marginBottom: "15px",
                  }}
                >
                  {solution.category?.toUpperCase(0).charAt(0) +
                    solution.category?.slice(1) || "SOLUTIONS"}
                </p>
                <h2 className="title">{solution.name}</h2>
              </div>
            </div>
          </div>

          <div className="row g-5 align-items-center">
            <img
              src={solution.image}
              alt={solution.name}
              style={{
                width: "100%",
                height: "auto",
                marginBottom: "55px",
                borderRadius: "25px",
              }}
            />
            <div className="col-lg-6">
              <div className="solution-overview-content">
                <h3 className="title mb--30">Overview</h3>
                <div
                  className="disc mb--20"
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{
                    __html: solution.overview
                      .split("\n")
                      .map((para) => `<p>${para}</p>`)
                      .join(""),
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="solution-features-grid">
                {solution.features &&
                  solution.features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Advantages & Applications Section */}
      {((solution.advantages && solution.advantages.length > 0) ||
        (solution.applications && solution.applications.length > 0)) && (
        <div
          className="rts-service-area rts-section-gapBottom bg-light solution-advantages-applications-section"
          style={{ paddingTop: "50px" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                  <p
                    className="brand-promise-tagline"
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#DF0A0A",
                      marginBottom: "15px",
                    }}
                  >
                    Benefits & Applications
                  </p>
                  <h2 className="title">Key Advantages & Where We Excel</h2>
                </div>
              </div>
            </div>
            <div className="row g-5">
              {/* Advantages Column */}
              {solution.advantages && solution.advantages.length > 0 && (
                <div className="col-lg-6 fade-in-up">
                  <div className="advantages-column">
                    <div className="section-subtitle mb--40">
                      <i
                        className="fas fa-check-circle"
                        style={{ color: "#DF0A0A", marginRight: "10px" }}
                      ></i>
                      <h3 className="title">Key Advantages</h3>
                    </div>
                    <ul className="advantages-list">
                      {solution.advantages.map((advantage, index) => (
                        <li key={index} className="advantage-item">
                          <div
                            className="advantage-content"
                            dangerouslySetInnerHTML={{ __html: advantage }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* Applications Column */}
              {solution.applications && solution.applications.length > 0 && (
                <div className="col-lg-6 fade-in-up">
                  <div className="applications-column">
                    <div className="section-subtitle mb--40">
                      <i
                        className="fas fa-industry"
                        style={{ color: "#DF0A0A", marginRight: "10px" }}
                      ></i>
                      <h3 className="title">Where We Excel</h3>
                    </div>
                    <ul className="applications-list">
                      {solution.applications.map((application, index) => (
                        <li key={index} className="application-item">
                          <div
                            className="application-content"
                            dangerouslySetInnerHTML={{ __html: application }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Other Details HTML Section */}
      {solution.other_details_html && (
        <div className="rts-service-area rts-section-gapBottom bg-light solution-other-details-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="solution-other-details-content"
                  dangerouslySetInnerHTML={{
                    __html: solution.other_details_html,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Product Types Section */}
      {/* {solution.products && solution.products.length > 0 && (
                <div className="rts-service-area rts-section-gapBottom bg-light solution-products-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                                    <span className="pre-title">PRODUCT RANGE</span>
                                    <h2 className="title">Our Product Portfolio</h2>
                                </div>
                            </div>
                        </div>

                        {solution.products.map((product, productIndex) => (
                            <div key={productIndex} className="solution-product-item mb--50">
                                <div className="row g-5 align-items-center">
                                    <div className={`col-lg-6 ${product.imageOrder === 'right' ? 'order-lg-2' : ''}`}>
                                        <div className="product-content">
                                            <h3 className="title mb--20">{product.title}</h3>
                                            <p className="disc mb--20">
                                                {product.description}
                                            </p>
                                            {product.detailedDescription && (
                                                <p className="disc mb--30">
                                                    {product.detailedDescription}
                                                </p>
                                            )}
                                            <div className="product-features">
                                                {product.features.map((feature, featureIndex) => (
                                                    <div key={featureIndex} className="feature-row">
                                                        <i className="fas fa-check"></i>
                                                        <span>{feature}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-lg-6 ${product.imageOrder === 'right' ? 'order-lg-1' : ''}`}>
                                        <div className="product-benefits">
                                            <h5 className="title mb--20">Advantages</h5>
                                            <ul className="benefits-list">
                                                {product.advantages.map((advantage, advIndex) => (
                                                    <li key={advIndex}>{advantage}</li>
                                                ))}
                                            </ul>
                                            <h5 className="title mt--30 mb--20">Applications</h5>
                                            <ul className="benefits-list">
                                                {product.applications.map((application, appIndex) => (
                                                    <li key={appIndex}>{application}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )} */}

      {/* Engineering & Compliance Section */}
      {/* {solution.compliance && (
                <div className="rts-about-area rts-section-gap solution-compliance-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                                    <span className="pre-title">COMPLIANCE</span>
                                    <h2 className="title">Engineering & Compliance</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4">
                            {solution.compliance.standards && solution.compliance.standards.length > 0 && (
                                <div className="col-lg-4 col-md-6 fade-in-up stagger-1">
                                    <div className="compliance-card">
                                        <h5 className="title">Standards</h5>
                                        <ul className="compliance-list">
                                            {solution.compliance.standards.map((standard, index) => (
                                                <li key={index}>{standard}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                            {solution.compliance.protectionClasses && solution.compliance.protectionClasses.length > 0 && (
                                <div className="col-lg-4 col-md-6 fade-in-up stagger-2">
                                    <div className="compliance-card">
                                        <h5 className="title">Protection Classes</h5>
                                        <ul className="compliance-list">
                                            {solution.compliance.protectionClasses.map((protection, index) => (
                                                <li key={index}>{protection}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                            {solution.compliance.structuralDesign && solution.compliance.structuralDesign.length > 0 && (
                                <div className="col-lg-4 col-md-6 fade-in-up stagger-3">
                                    <div className="compliance-card">
                                        <h5 className="title">Structural Design</h5>
                                        <ul className="compliance-list">
                                            {solution.compliance.structuralDesign.map((design, index) => (
                                                <li key={index}>{design}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )} */}

      {/* Why Choose Sembian Section */}
      <div className="rts-service-area rts-section-gapBottom bg-light solution-why-choose-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                <p
                  className="brand-promise-tagline"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#DF0A0A",
                    marginBottom: "15px",
                  }}
                >
                  Why We?
                </p>
                <h2 className="title">Why Choose Sembian?</h2>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-lg-6 col-md-6 fade-in-up stagger-1">
              <div className="why-choose-card">
                <div className="why-choose-header">
                  <h5 className="title">Integrated Engineering</h5>
                </div>
                <p className="disc">
                  Structural, electrical, HVAC, and safety systems designed as
                  one unit
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 fade-in-up stagger-2">
              <div className="why-choose-card">
                <div className="why-choose-header">
                  <h5 className="title">Customization</h5>
                </div>
                <p className="disc">
                  Configurable layouts, materials, and climatic ratings
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 fade-in-up stagger-3">
              <div className="why-choose-card">
                <div className="why-choose-header">
                  <h5 className="title">Global Experience</h5>
                </div>
                <p className="disc">
                  Proven track record in refineries, LNG, hydrogen, and power
                  projects
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 fade-in-up stagger-4">
              <div className="why-choose-card">
                <div className="why-choose-header">
                  <h5 className="title">Compliance Ready</h5>
                </div>
                <p className="disc">
                  ATEX, IECEx, and PESO conformity for hazardous area operations
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 fade-in-up stagger-5">
              <div className="why-choose-card">
                <div className="why-choose-header">
                  <h5 className="title">Sustainability</h5>
                </div>
                <p className="disc">
                  Energy-efficient HVAC and recyclable material selection
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 fade-in-up stagger-6">
              <div className="why-choose-card">
                <div className="why-choose-header">
                  <h5 className="title">Innovation</h5>
                </div>
                <p className="disc">
                  Experience the innovations of our multi-disciplinary expertise
                  for a greater results
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="rts-service-area rts-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="solution-cta-modern">
                <div className="solution-cta-background">
                  <div className="solution-cta-overlay"></div>
                  <div className="solution-cta-content">
                    <div className="row align-items-center g-4">
                      <div className="col-lg-8 col-md-7">
                        <div className="solution-cta-text">
                          <div className="solution-cta-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={60}
                              height={60}
                              viewBox="0 0 60 60"
                              fill="none"
                            >
                              <circle
                                cx="30"
                                cy="30"
                                r="30"
                                fill="rgba(255, 255, 255, 0.15)"
                              />
                              <path
                                d="M30 20L35 25L30 30L25 25L30 20Z"
                                fill="#ffffff"
                              />
                              <path
                                d="M35 25L40 30L35 35L30 30L35 25Z"
                                fill="#ffffff"
                              />
                              <path
                                d="M25 25L30 30L25 35L20 30L25 25Z"
                                fill="#ffffff"
                              />
                            </svg>
                          </div>
                          <h3 className="solution-cta-title">
                            Ready to Transform Your Process?
                          </h3>
                          <p className="solution-cta-description">
                            Partner with Sembian for your next technologically
                            advanced engineering project – from concept design
                            to on-site commissioning. Let’s discuss how we can
                            deliver precision-engineered solutions tailored
                            specially to your needs.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-5">
                        <div className="solution-cta-action">
                          <Link
                            className="rts-btn btn-white solution-cta-btn"
                            to={"/contactus"}
                          >
                            <span>Get In Touch</span>
                            <i className="fas fa-arrow-right"></i>
                          </Link>
                          <div className="solution-cta-phone">
                            <i className="fas fa-phone-alt"></i>
                            <div>
                              <span>Need Help?</span>
                              <a href="tel:+917305121778">+91-422-23419872</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterTwo />
    </div>
  );
}

export default SolutionDetails;
